import axios from 'axios';

const axiosInstance = axios.create();

// ✅ Only add interceptors if in browser (prevents test crashes)
if (typeof window !== 'undefined') {
        axiosInstance?.interceptors?.response?.use(
            (response) => response,
            (error) => Promise.reject(error)
        );
}

export default axiosInstance;
